export const IssueTypePolicy = ({

    ISSUE_TYPE_EDI : "EDI",
    ISSUE_TYPE_HARD_COPY : "HARDCOPY",
    ISSUE_TYPE_SOFT_COPY : "SOFTCOPY",
    ISSUE_TYPE_EMAIL : "EMAIL",
    ISSUE_TYPE_E_INVOICE : "E-INVOICE",
    ISSUE_TYPE_P_PRINT : "P-PRINT"
})
